// Force the NeedHelp to roll up without shifting content down
import { useCallback, useEffect, useRef, useState } from 'react'

export function useSticky() {
  const [isSticky, setSticky] = useState(false)
  const stickyElementRef = useRef(null)
  const elementRef = useRef(null)

  const handleScroll = useCallback(() => {
    if (!elementRef || !stickyElementRef) return

    if (stickyElementRef?.current && elementRef?.current) {
      // @ts-ignore
      const elementHeight = elementRef.current.getBoundingClientRect().height
      // @ts-ignore
      const stickyElementHeight = stickyElementRef.current.getBoundingClientRect().height
      if (window.scrollY + stickyElementHeight > elementHeight) {
        setSticky(true)
      } else {
        setSticky(false)
      }
    }
  }, [stickyElementRef, elementRef])

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', () => handleScroll)
    }
  }, [handleScroll])

  return { isSticky: !!isSticky, stickyElementRef, elementRef }
}
